import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ComponentPart from './ComponentPart';
import {
  getComponentParts,
  getOrganisationManager,
  getUserProfileUnit,
  getApprovedComponent,
  getAllComponentPositions,
  getUnitConfiguration,
  getModelVariantManager,
  getModelCategoryManager,
} from '../../selectors/index';
import { describeComponentPartThunk, saveComponentPartThunk, setComponentPartChangeThunk } from '../../actions/componentParts';
import { getOrganisationsThunk } from '../../actions/organisationManager';
import { getApprovedComponentThunk } from '../../actions/approvedComponents';
import { getModelCategoriesThunk } from '../../actions/modelCategory';
import { getComponentPartsByUnitThunk } from '../../actions/unitConfiguration';
import { getModelComponentPositionsThunk } from '../../actions/modelVariant';
import { getSelectedUserProfileWidgetsThunk } from '../../actions/UserProfileWidgets';

const mapStateToProps = state => {
  return {
    componentParts: getComponentParts(state),
    organisationManager: getOrganisationManager(state),
    allowedUnits: getUserProfileUnit(state),
    approvedComponents: getApprovedComponent(state),
    allModelComponentPositions: getAllComponentPositions(state),
    unitConfiguration: getUnitConfiguration(state),
    modelVariantManager: getModelVariantManager(state),
    modelCategoryManager: getModelCategoryManager(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      describeComponentPart: componentPartId => describeComponentPartThunk(componentPartId, 'PARTSEDIT'),
      saveComponentPart: (componentPart, widgetCode) => saveComponentPartThunk(componentPart, widgetCode),
      changeComponentPart: componentPart => setComponentPartChangeThunk(componentPart),
      getOrganisations: (offset, limit, filter, widgetCode) => getOrganisationsThunk(offset, limit, filter, widgetCode),
      getApprovedComponents: (filterObj, widgetCode, modelCategoryId) => getApprovedComponentThunk(filterObj, widgetCode, modelCategoryId),
      getComponentPartsByUnit: unitId => getComponentPartsByUnitThunk(unitId, 'PARTSEDIT'),
      getModelComponentPositions: (modelId, onlyVirtual, telemetryComponent, widgetCode) =>
        getModelComponentPositionsThunk(modelId, onlyVirtual, telemetryComponent, widgetCode),
      getSelectedUserProfileWidgets: (profileId, userName) => getSelectedUserProfileWidgetsThunk(profileId, userName, 'GENERALACCESS'),
      getModelCategories: (offset, limit, filter, widget, organisationId) => getModelCategoriesThunk(offset, limit, filter, widget, organisationId),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ComponentPart);
